import React, { FC, Fragment } from 'react';
import { Trans } from 'react-i18next';
import { Button } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { S3ObjectInput } from 'api';
import { AspectRatios } from 'types/app';
import { Uploader, UploadDialog, UploadInput, IUploader } from 'components';

interface IProps extends WithStyles<typeof styles> {
  hexColor: string;
  onSave: (image: S3ObjectInput) => void;
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    button: {
      color: palette.common.white,
      marginBottom: spacing(4),
      '&:hover': {
        opacity: 0.9,
      },
    },
  });

const ImageUpload: FC<IProps> = ({ classes, hexColor, onSave }) => (
  <Uploader>
    {(uploaderProps: IUploader) => (
      <Fragment>
        <UploadInput onUpload={uploaderProps.onUpload}>
          <Button
            component="span"
            size="large"
            style={{ backgroundColor: hexColor }}
            className={classes.button}
            variant="contained"
            fullWidth>
            <Trans i18nKey="groups:imageUpload" />
          </Button>
        </UploadInput>
        <UploadDialog
          i18nKey="groups:imageUpload"
          aspectRatio={AspectRatios.square}
          onSave={onSave}
          {...uploaderProps}
        />
      </Fragment>
    )}
  </Uploader>
);

export default withStyles(styles)(ImageUpload);
